import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { LoadingButton } from '@mui/lab';
import { Avatar, Button, Paper, Stack, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import FolderIcon from "@mui/icons-material/Folder";
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom';
import { BACKEND_APP_URL } from 'app/utils/constants/paths';
import { Download } from '@mui/icons-material';

const LotCreation = () => {
  const [disbleButton, setDisbleButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  // const [Headdata, setHeadData] = useState(null);
  const apiRef = useRef();

  const swal = useSwalWrapper()
  const fetchLotDetail = useCallback(async () => {
    data && setData(null)
    setDisbleButton(true)
    await jwtAuthAxios.get('/bulk/getlotdata').then(async res => {
      setData(res.data);
      setDisbleButton(false)
    }).catch(r => swal.fire({
      icon: 'error',
      text: r,
    }))
  })
  useEffect(fetchLotDetail, [])
  const columns = [
    { field: "FL_TYPE", flex: 1, headerName: "Type" },
    { field: "FL_SHAPE_NAME", flex: 1, headerName: "SHAPE", type: 'text', editable: true },
    { field: "FL_MAIN_LOT", flex: 1, headerName: "Main Lot", type: 'text'},
    { field: "FL_SUB_LOT", flex: 1, headerName: "Sub Lot", type: 'text' },
    { field: "FL_SIZE", flex: 1, headerName: "Size", editable: true, type: "text" },
    { field: "COLORCODE", flex: 1, headerName: "Col.", type: 'text', editable: true },
    { field: "CLARITY", flex: 1, headerName: "Clarity", type: 'text', editable: true },
    { field: "FL_LENGTH", flex: 1, headerName: "L", type: 'text', editable: true },
    { field: "FL_WIDTH", flex: 1, headerName: "W", type: 'text', editable: true },
    { field: "FL_HIGHT", flex: 1, headerName: "H", type: 'text', editable: true },

  ];
  const getFieldName = (key) => {
    switch (key) {
      case 'Type':
        return 'FL_TYPE'
        break;
      case 'SHAPE':
        return 'FL_SHAPE_NAME'
        break;
      case 'Main Lot':
        return 'FL_MAIN_LOT'
        break;
      case 'Sub Lot':
        return 'FL_SUB_LOT'
        break;
      case 'Size':
        return 'FL_SIZE'
        break;
      case 'Col':
        return 'COLORCODE'
        break;
      case 'Clarity':
        return 'CLARITY'
        break;
      case 'L':
        return 'FL_LENGTH'
        break;
      case 'W':
        return 'FL_WIDTH'
        break;
      case 'H':
        return 'FL_HIGHT'
        break;
      default:
        return key
        break;
    }
  }
  const handleButtonClick = async (props) => {
    // Get all promises for updating rows
    // if(props.id > 10000 && props.row.P_CODE != null){
    //   alert('field is not editable')
    //   setData(data);
    //   setDisbleButton(false)
    //   return
    // }
    setTimeout(async () => {
      // console.log( );
      // if( (props.id > 10000 || props.row.P_CODE) && (props.field != 'SHORT' && props.field != 'ANAME' && props.field != 'ACH_NAME')) {
      const updatedCellValue = await apiRef.current.getCellValue(props.id, props.field);
      const updatedRows = await Promise.all(
        data.map(async (row) => {
          // console.log(row.FL_ID, props.id);
          if (row.FL_ID == props.id) {
            return { ...row, [props.field]: updatedCellValue, Edited: true };
          }
          return row;
        })
      );
      // console.log(updatedRows);
      setData(updatedRows);
      setDisbleButton(false)
      // }
    }, 100);
    // Update the state or perform other operations with updatedRows
  };
  const saveDataHandler = async () => {
    setLoading(false)
    // console.log(data);
    let FrmData = await data.filter(s=> s.Edited == true)
    await jwtAuthAxios.post('/bulk/getlotdata',{"lotdata":FrmData}).then(res=>{
      swal.fire({
        icon: 'success',
        text: res.data.message,
      });
      fetchLotDetail()
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: e,
      });    
      }).finally(e=>{
        setLoading(false)
      });
  }
  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileInputChange = (event) => {
    const files = event.target.files;
    const file = event.target.files[0];
    const reader = new FileReader();
if(!file){
return
}
    reader.onload = (e) => {
      const UNITdata = new Uint8Array(e.target.result);
      const workbook = XLSX.read(UNITdata, { type: 'array' });

      // Assuming the first sheet is the one you want to convert
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet to JSON format
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      // const result = 

      const REOBJ = jsonData.slice(1).map(row => {
        const obj = {};
        jsonData[0].forEach((key, index) => {
          obj[`${getFieldName(key.trim())}`] = row[index];
        });
        return { ...obj, Edited: true, FL_ID: `new-${obj.FL_SUB_LOT}-${obj.FL_MAIN_LOT}` };
      });
      setData([...REOBJ, ...data])
    };
    
    reader.readAsArrayBuffer(file);
    // console.log(files);
    // Handle the file upload logic here...
  };
  // useEffect(()=>{
  //   console.log(data?.map(row=> row.LID) );
  // },[data])

  return (
    <JumboCardQuick action={<Stack direction={"row"} justifyContent={'end'} spacing={2}>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileInputChange}
      />
      <Tooltip title="Upload Data"><Avatar onClick={handleUploadClick}><FolderIcon /></Avatar></Tooltip>
      <Tooltip title="DownLoad Lot Data"><Link to={`${BACKEND_APP_URL}demo/PARCEL_LOT_CREATION.xlsx`} target='_blank'><Avatar><Download /></Avatar></Link></Tooltip>
      <LoadingButton disabled={disbleButton} loading={loading} variant='contained' onClick={saveDataHandler}>Save</LoadingButton></Stack>} sx={{ p: 0 }} title={'Lot Creation'} >

      <Paper elevation={0} sx={({ backgroundColor: theme => theme.palette.action.hover, p: 0 })}>
        {!Boolean(data) ? <TableSkeleton /> : <DataGrid
          rows={data || []}
          columns={columns}
          pageSize={5}
          apiRef={apiRef}
          density='compact'
          getRowId={(row) => row.FL_ID}
          rowsPerPageOptions={[50, 100, 200]}
          sx={{ p: 0, fontSize: '16px' }}
          onCellEditStart={(pams) => setDisbleButton(true)}
          onCellEditStop={handleButtonClick}
          disableRowSelectionOnClick
        />}
      </Paper>
    </JumboCardQuick>
  )
};
LotCreation.Modulename = 'LotCreation';
export default LotCreation;

